import AbstractInstaller from "../../core/application/AbstractInstaller";
import ScenarioPlayerEvent from "../scenario/ScenarioPlayerEvent";
import DraftEmailAvailableCommand from "./controller/DraftEmailAvailableCommand";
import EmailAvailableCommand from "./controller/EmailAvailableCommand";
import EmailModel from "./model/EmailModel";

export default class EmailInstaller extends AbstractInstaller {
    constructor(injector, commands, mediatorMap) {
        super(injector, commands, mediatorMap);

        injector.mapClass("emailModel", EmailModel, true);

        commands.add(ScenarioPlayerEvent.EMAIL_AVAILABLE, EmailAvailableCommand);
        commands.add(ScenarioPlayerEvent.DRAFT_EMAIL_AVAILABLE, DraftEmailAvailableCommand);
    }
}